import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, Star, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  useEffect(() => {
    const t = setInterval(next, 7000);
    return () => clearInterval(t);
  }, []);

  const item = TESTIMONIALS[i];

  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-36 bg-brand-charcoal text-brand-cream overflow-hidden grain-overlay"
    >
      <Quote
        size={420}
        className="absolute -top-20 -left-20 text-brand-red/10 pointer-events-none"
        strokeWidth={1}
      />
      <Quote
        size={300}
        className="absolute -bottom-20 -right-10 text-brand-mustard/10 pointer-events-none rotate-180"
        strokeWidth={1}
      />

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <span className="font-heading uppercase text-[11px] tracking-[0.3em] font-bold text-brand-mustard">
          · Word on the Street
        </span>
        <h2 className="mt-3 font-display uppercase text-5xl md:text-6xl lg:text-7xl leading-[0.9]">
          What our<br />
          <span className="text-brand-mustard italic">regulars say.</span>
        </h2>

        <div className="mt-14 min-h-[260px] relative">
          <AnimatePresence mode="wait">
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
              data-testid="testimonial-card"
            >
              <div className="flex justify-center gap-1 mb-7">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={20} className="text-brand-mustard fill-brand-mustard" />
                ))}
              </div>
              <p className="font-heading text-2xl md:text-3xl lg:text-4xl leading-snug font-medium text-brand-cream text-balance max-w-4xl mx-auto">
                "{item.quote}"
              </p>
              <div className="mt-10">
                <div className="font-display uppercase text-2xl text-brand-mustard">
                  {item.name}
                </div>
                <div className="font-heading uppercase text-[10px] tracking-[0.25em] font-bold mt-1 text-brand-cream/60">
                  {item.role}
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center justify-center gap-4">
          <button
            onClick={prev}
            data-testid="testimonial-prev"
            aria-label="Previous review"
            className="w-12 h-12 rounded-full border border-brand-cream/20 hover:bg-brand-cream hover:text-brand-charcoal flex items-center justify-center transition-all hover:-translate-x-1"
          >
            <ChevronLeft size={18} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                aria-label={`Go to review ${idx + 1}`}
                className={`h-1.5 rounded-full transition-all ${
                  idx === i ? "w-10 bg-brand-mustard" : "w-1.5 bg-brand-cream/30"
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            data-testid="testimonial-next"
            aria-label="Next review"
            className="w-12 h-12 rounded-full border border-brand-cream/20 hover:bg-brand-cream hover:text-brand-charcoal flex items-center justify-center transition-all hover:translate-x-1"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
